import { Component, OnInit } from '@angular/core';

import { CapabilitiesService } from '../shared/shared-context/capabilities.service';
import { AuthType, ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';

@Component({
    selector: 'ohp-pwa',
    templateUrl: './pwa.component.html'
})
export class PwaComponent implements OnInit {
    public showPlaces: boolean;
    public showSuggestedActions: boolean;

    constructor(
        private readonly capabilitiesService: CapabilitiesService,
        private readonly clientStartupConfigService: ClientStartupConfigService
    ) {
    }

    public ngOnInit() {
        this.showSuggestedActions = this.capabilitiesService.capabilities.suggestedActionsEnabled;
        this.showPlaces = this.clientStartupConfigService.config.authType === AuthType.OrgId && !this.capabilitiesService.capabilities.edgeworthEnabled;
    }
}
